import React from "react";
import Navbar from "../component/Navbar";
import Index from "../component/About";

import Footer from "../component/Footer";
import Putfirst from "../component/About/Putfirst";

import TeamSection from "../component/About/TeamSection";
import Calltoaction from "../component/Calltoaction";
import FAQSection from "../component/FAQSection";
import BlogPreview from "../component/BlogPreview";

const Aboutus = () => {
  return (
    <div className="w-full">
      <Navbar />
      <Index />
      <TeamSection />
      <Putfirst />
      <Calltoaction />
      <FAQSection />
      <BlogPreview />

      <Footer />
    </div>
  );
};

export default Aboutus;
